module.exports = __webpack_public_path__ + "img/image21.0f3295ae.jpg";